import React from 'react'
import { SearchIcon, XIcon } from 'lucide-react'
import { mobile } from './tokens'

interface MobileSearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  autoFocus?: boolean
}

export function MobileSearchField({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
  autoFocus,
}: MobileSearchFieldProps) {
  return (
    <div className={`relative w-full min-w-0 ${className}`.trim()}>
      <SearchIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
      <input
        type="search"
        enterKeyHint="search"
        autoFocus={autoFocus}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${mobile.field} pl-10 ${value ? 'pr-10' : 'pr-3.5'}`}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 min-h-[36px] min-w-[36px] inline-flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100"
          aria-label="Clear search"
        >
          <XIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  )
}
